module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n\t\t\t设置\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.t_data.base.title),
      callback: function($$v) {
        _vm.$set(_vm.t_data.base, "title", $$v)
      },
      expression: "t_data.base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.t_data.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.t_data.base, "subtitle", $$v)
      },
      expression: "t_data.base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.t_data.config.imgUrl) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.t_data.config.imgUrl
    },
    on: {
      "click": _vm.handleImgChange
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": _vm.handleImgChange
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "热区"
    }
  }, [_c('hotzone', {
    staticClass: "hotzone",
    attrs: {
      "image": _vm.t_data.config.imgUrl,
      "zonesInit": _vm.zonesList
    },
    on: {
      "add": _vm.handleAdd,
      "change": _vm.handleChange,
      "remove": _vm.handleRemove
    }
  }), _vm._v(" "), _vm._l((_vm.t_data.data), function(item, index) {
    return _c('div', {
      staticClass: "setting-item slider"
    }, [_c('div', {
      staticClass: "uploader-setting"
    }, [_c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }, [(item.id) ? _c('div', {
      staticClass: "link-content"
    }, [(item.linkPage === 'goods') ? [_vm._v("商品：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'category') ? [_vm._v("分类：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'article') ? [_vm._v("文章：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'link') ? [_vm._v("页面：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'marketing') ? [_vm._v("营销：")] : _vm._e(), _vm._v("\n\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t")], 2) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }), _vm._v("设置路径")])])])])
  })], 2)], 1)], 1)]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeimgsVisible
    }
  }), _vm._v(" "), _c('linkSetter', {
    attrs: {
      "visible": _vm.linksVisible,
      "show_article": false,
      "show_planting": false,
      "show_page": false,
      "show_marketing": false,
      "show_store": false
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": _vm.closeDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0de6c8b8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de6c8b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/imgHotzone/style.vue
// module id = 2463
// module chunks = 0